import { Separator } from "@/components/ui/separator";
import { Switch } from "@/components/ui/switch";

interface NotificationToggleProps {
  title: string;
  description: string;
  enabled: boolean | undefined;
  onChange?: (checked: boolean) => void;
  showSeparator?: boolean;
}

export function NotificationToggle({
  title,
  description,
  enabled,
  onChange,
  showSeparator = true
}: NotificationToggleProps) {
  return (
    <>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium">{title}</p>
          <p className="text-xs text-muted-foreground">{description}</p>
        </div>
        <Switch
          checked={enabled ?? false}
          onCheckedChange={onChange ?? (() => {})}
          disabled={onChange === undefined}
        />
      </div>
      {showSeparator && <Separator />}
    </>
  );
}
